<template>
  <div class="transfer-container" v-loading="btnLoading">
    <!-- 左侧：未选择 -->
    <div class="transfer-panel left-panel">
      <div class="panel-header">
        <h4>未移交资质资料清单</h4>
        <el-input
          v-model="SarchData.Name"
          placeholder="请输入文件名称"
          clearable
          style="flex: 1; margin-right: 5px"
        >
        </el-input>

        <el-button type="primary" @click="handleSearch">查询</el-button>
      </div>

      <el-table
        ref="leftTable"
        height="100%"
        :data="leftData"
        v-loading="leftLoading"
        @selection-change="handleLeftSelectionChange"
        :row-class-name="getRowClassName"
        @row-click="handleLeftRowClick"
      >
        <el-table-column
          type="selection"
          width="55"
          align="center"
          :selectable="checkSelectable"
        ></el-table-column>
        <el-table-column
          type="index"
          label="序号"
          align="center"
          width="50"
        ></el-table-column>
        <el-table-column
          prop="TypeName"
          label="文件类型"
          align="center"
          sortable
          show-overflow-tooltip
        />
        <el-table-column
          prop="NewFileName"
          label="文件名称"
          align="center"
          sortable
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <a :href="scope.row.Url" target="_blank" style="color: #409eff">
              {{ scope.row.NewFileName }}
            </a>
          </template>
        </el-table-column>

        <el-table-column
          prop="SupplierName"
          label="供应商名称"
          align="center"
          sortable
          show-overflow-tooltip
        />
      </el-table>

      <!-- 分页 -->
      <div
        style="
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
        "
      >
        <el-pagination
          layout="total,prev, pager, next,sizes"
          :total="pagination.total"
          :current-page="pagination.current"
          :page-size="pagination.pageSize"
          :page-sizes="pagination.pageSizeOptions"
          style="display: flex; align-items: center"
          @current-change="currentChange"
          @size-change="handleSizeChange"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 中间：操作按钮 -->
    <div class="transfer-buttons">
      <el-button
        type="primary"
        icon="el-icon-arrow-right"
        :disabled="leftSelection.length === 0"
        @click="moveToRight"
      >
        添加
      </el-button>
      <el-button
        type="primary"
        icon="el-icon-arrow-left"
        :disabled="rightSelection.length === 0"
        @click="moveToLeft"
      >
        移除
      </el-button>
    </div>

    <!-- 右侧：已选择 -->
    <div class="transfer-panel right-panel">
      <div class="panel-header">
        <h4>本次移交配件清单</h4>
        <span class="selected-count">已选择 {{ rightData.length }} 项</span>
      </div>

      <el-table
        ref="rightTable"
        height="100%"
        :data="rightData"
        @selection-change="handleRightSelectionChange"
        @row-click="handleRightRowClick"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column
          type="index"
          label="序号"
          align="center"
          width="50"
        ></el-table-column>
        <el-table-column
          prop="TypeName"
          label="文件类型"
          align="center"
          sortable
          show-overflow-tooltip
        />
        <el-table-column
          prop="NewFileName"
          label="文件名称"
          align="center"
          sortable
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <a :href="scope.row.Url" target="_blank" style="color: #409eff">
              {{ scope.row.NewFileName }}
            </a>
          </template>
        </el-table-column>

        <el-table-column
          prop="SupplierName"
          label="供应商名称"
          align="center"
          sortable
          show-overflow-tooltip
        />
      </el-table>
      <div
        style="
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
        "
      >
        <div class="el-pagination__total">数量总计：{{ rightData.length }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      btnLoading: false,
      SarchData: {
        Name: '',
        DeviceType: '',
      },
      leftLoading: false,
      leftData: [],
      leftSelection: [],
      rightSelection: [],
      rightData: [],
      searchTimer: null, // 防抖定时器
      pagination: {
        total: 0,
        current: 1,
        pageSize: 20,
        pageSizeOptions: [10, 20, 50, 100],
      },
    }
  },
  props: {
    DeviceTypeData: {
      type: Array,
      default: () => [],
    },
    pId: {
      type: String,
      default: '',
    },
    value: {
      type: Array,
      default: () => [],
    },
    SupplierId: {
      type: Array,
      default: () => [],
    },
  },
  components: {},
  methods: {
    handleRightRowClick(row) {
      console.log(row)
      this.$refs.rightTable.toggleRowSelection(row)
    },

    // 右侧表格选中变化
    handleRightSelectionChange(selection) {
      this.rightSelection = selection
    },
    // 向右移动（添加到分组）
    moveToRight() {
      if (this.leftSelection.length === 0) {
        this.$notify.warning('请选择要添加的客户')
        return
      }
      // 将选中的项添加到右侧
      this.rightData.push(...this.leftSelection)
      // 清空左侧选中，但不移除数据
      this.leftSelection = []
      this.$refs.leftTable.clearSelection()
      this.$notify.success(
        `已添加 ${this.leftSelection.length || this.rightData.length} 项`
      )
      // 强制刷新左侧表格以更新选择状态
      this.$nextTick(() => {
        this.$refs.leftTable.doLayout()
      })
      this.$emit('input', [...this.rightData])
    },

    // 向左移动（从分组中移除）
    moveToLeft() {
      if (this.rightSelection.length === 0) {
        this.$notify.warning('请选择要移除的设备')
        return
      }

      // 从右侧移除选中的项
      const selectedIds = this.rightSelection.map((item) => item.Id)
      this.rightData = this.rightData.filter(
        (item) => !selectedIds.includes(item.Id)
      )

      // 清空右侧选中
      this.rightSelection = []
      this.$refs.rightTable.clearSelection()

      this.$notify.success(`已移除 ${selectedIds.length} 项`)

      // 强制刷新左侧表格以更新选择状态
      this.$nextTick(() => {
        this.$refs.leftTable.doLayout()
      })
      this.$emit('input', [...this.rightData])
    },
    // 获取（左侧数据）
    getDataList() {
      this.leftLoading = true
      this.$http
        .post(
          '/Base_ProjectWork/project_taskhandover/GetProjectSupplierTypeFilesList ',
          {
            PageIndex: this.pagination.current,
            PageRows: this.pagination.pageSize,
            SortField: 'Id',
            SortType: 'desc',
            Search: [
              {
                Condition: 'ProjectId',
                Keyword: this.pId,
              },
              {
                Condition: 'Name',
                Keyword: this.SarchData.Name,
              },
              {
                Condition: 'SupplierId',
                Keyword:
                  this.SupplierId && this.SupplierId.length > 0
                    ? this.SupplierId.join(',')
                    : '',
              },
            ],
          }
        )
        .then((res) => {
          this.leftLoading = false
          if (res.Success) {
            // 不过滤数据，显示所有客户，但通过状态显示和禁止选择来区分
            this.leftData = res.Data
            this.pagination.total = res.Total
          } else {
            this.leftData = []
            this.$notify.error(res.Msg)
          }
        })
        .catch(() => {
          this.leftLoading = false
          this.leftData = []
          this.$notify.error('获取数据失败')
        })
    },
    // 分页变化
    currentChange(page) {
      this.pagination.current = page
      this.getDataList()
    },

    // 每页数量变化
    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.current = 1
      this.getDataList()
    },
    // 检查行是否在右侧数据中
    isInRightData(row) {
      return this.rightData.some(
        (item) => item.Id === row.Id || item.CusId === row.Id
      )
    },
    // 设置行的样式类名
    getRowClassName({ row }) {
      if (this.isInRightData(row)) {
        return 'disabled-row'
      }
      return ''
    },
    // 检查行是否可选择
    checkSelectable(row) {
      return !this.isInRightData(row)
    },
    handleSearch() {
      if (this.SupplierId && this.SupplierId.length > 0) {
        if (this.searchTimer) {
          clearTimeout(this.searchTimer)
        }

        this.searchTimer = setTimeout(() => {
          this.pagination.current = 1
          this.getDataList()
        }, 500)
      } else {
        return this.$notify.warning('请选择供应商后查询')
      }
    },
    // 左侧表格选中变化
    handleLeftSelectionChange(selection) {
      this.leftSelection = selection
    },
    handleLeftRowClick(row) {
      if (this.checkSelectable(row)) {
        this.$refs.leftTable.toggleRowSelection(row)
      }
    },
  },
  mounted() {},
  created() {},
  computed: {},
  watch: {
    SupplierId: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val && val.length > 0) {
          this.handleSearch()
        } else {
          this.leftData = []
          this.pagination.total = 0
        }
      },
    },
    value: {
      deep: true,
      immediate: true,
      handler(val) {
        this.rightData = [...val]
      },
    },
  },
}
</script>
<style lang="scss" scoped>
.transfer-container {
  display: flex;
  width: 100%;
  height: calc(100%);
  gap: 20px;
}
.transfer-panel {
  flex: 1;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
}

.panel-header {
  padding: 12px 16px;
  border-bottom: 1px solid #e0e0e0;
  background: #fafafa;
  display: flex;
  // justify-content: space-between;
  align-items: center;

  h4 {
    margin: 0;
    font-size: 14px;
    font-weight: 500;
    margin-right: 20px;
  }

  .selected-count {
    color: #909399;
    font-size: 12px;
  }
}
::v-deep .el-table {
  flex: 1;
}

::v-deep .el-input {
  width: 100%;
}

// 已分组行样式
::v-deep .disabled-row {
  background-color: #f5f7fa;
  color: #909399;
}

::v-deep .disabled-row .el-checkbox {
  cursor: not-allowed;
}

::v-deep .disabled-row .el-checkbox__inner {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  cursor: not-allowed;
}

::v-deep .disabled-row:hover {
  background-color: #f5f7fa !important;
}
.transfer-buttons {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 12px;
  align-items: center;
  width: 80px;

  .el-button {
    width: 60px;
    padding: 8px 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
  }
}
</style>
